import { ExpandMore } from '@mui/icons-material';
import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { memo, useCallback, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { useFormikContext } from 'formik';
import { ElectoralFormVM } from 'front-office/view-models/electoral/electoral-form';
import ElectoralCheckboxes from './form';

const ElectoralAnprComponent = (): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  const formContext = useFormikContext<ElectoralFormVM>();

  const onChange = useCallback(
    (identifier) => {
      const isSelected =
        formContext.values.electoral?.key.codiceDocumento === identifier.key.codiceDocumento;

      if (!formContext.values.certificateInternOnly && identifier.dettaglioModalitaRilascio) {
        formContext.setValues({
          ...formContext.values,
          modality: isSelected
            ? undefined
            : {
                id: identifier.dettaglioModalitaRilascio.key.codiceModalitaRilascio,
                value: identifier.dettaglioModalitaRilascio.descrizione,
                amountTaxStamp: identifier.dettaglioModalitaRilascio.importoImpostaBollo
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoImpostaBollo)
                  : 0,
                amountRightsSecretariat: identifier.dettaglioModalitaRilascio
                  .importoDirittiSegreteria
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiSegreteria)
                  : 0,
                amountRightsCivilState: identifier.dettaglioModalitaRilascio
                  .importoDirittiStatoCivile
                  ? Number.parseFloat(
                      identifier.dettaglioModalitaRilascio.importoDirittiStatoCivile
                    )
                  : 0,
                amountFixedRights: identifier.dettaglioModalitaRilascio.importoDirittiFissi
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoDirittiFissi)
                  : 0,
                amountExpenses: identifier.dettaglioModalitaRilascio.importoSpese
                  ? Number.parseFloat(identifier.dettaglioModalitaRilascio.importoSpese)
                  : 0,
                codeExemptionAnpr: identifier.dettaglioModalitaRilascio.codiceEsenzioneAnpr,
                registryType: identifier.dettaglioModalitaRilascio.tipoRegistro,
                descrizioneModalitaStampa:
                  identifier.dettaglioModalitaRilascio.descrizioneModalitaStampa,
                disabled: true,
              },
          electoral: isSelected ? undefined : identifier,
        });

        return;
      }

      formContext.setFieldValue('electoral', isSelected ? undefined : identifier);
    },
    [formContext.setFieldValue, formContext.values]
  );

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-electoral-anpr-content"
        id="panel-electoral-anpr-header"
        expandIcon={<ExpandMore />}
      >
        <Typography>Certificati Elettorale</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2}>
          <ElectoralCheckboxes
            onChange={onChange}
            values={formContext.values.electoral}
            isAire={
              formContext.values.accountholder?.isAire ||
              (formContext.values.isAire && formContext.values.accountholder?.sameApplicant)
                ? '1'
                : '0'
            }
          />
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
};

ElectoralAnprComponent.displayName = 'Accordion historical anpr component';

const ElectoralAnpr = memo(ElectoralAnprComponent);

export default ElectoralAnpr;
